import {ReservedOfferResponse} from "@/types/service-response";

export default class ReservedOffer {
  private constructor(
      readonly dailyMenuOffer: any,
      readonly agreedUnitPrice: string,
      public amount: number,
  ) {}


  static createFromResponse(responseData: ReservedOfferResponse): ReservedOffer {

    return new ReservedOffer(
        responseData.dailyMenuOffer,
        responseData.agreedUnitPrice,
        responseData.amount ? responseData.amount : 1,
    )
  }

  static createFromResponseList(responseData: ReservedOfferResponse[]): ReservedOffer[] {
    return responseData.map((item:ReservedOfferResponse) => {
      return new ReservedOffer(
          item.dailyMenuOffer,
          item.agreedUnitPrice,
          item.amount ? item.amount : 1
      )
    })
  }
}